<template>
  <div class="table-container">
    <div class="table-header">
      <div class="table-header-title align-center d-flex ga-2">
        <div class="d-flex ga-2">
          <v-icon :class="[mode]" :icon="icon" />
          <span>{{ title }}</span>
        </div>
      </div>

      <!-- Dynamic Labels Section -->
      <div class="d-flex flex-row align-center justify-space-between ga-2">
        <div
          v-if="labels && labels.length > 0 && showLabels"
          class="labels-section d-flex flex-row align-center justify-space-between"
          :style="{ gap: '10px' }"
        >
          <TinyLabel
            v-for="(label, index) in labels"
            :key="index"
            :class="[
              'red',
              'clickable-label',
              { 'active-label': label.isActive },
            ]"
            @click="onLabelClick(label.filterKey)"
          >
            {{ typeof label === "string" ? label : label.text }}
          </TinyLabel>
        </div>
        <slot name="print-icon-header"></slot>
        <FilterButton
          v-if="showFilterButton && (isMobile || isTablet || isLaptop)"
          :mode="filterMode"
        />
      </div>

      <div
        class="d-flex ga-2 align-center"
        style="line-height: 0.7"
        :class="[isMobile ? 'flex-column ga-0' : '']"
      >
        <div class="sum-count">
          <span>
            סה"כ
            <span class="sum-content" :class="[mode]">{{ sumCount }}</span>
            {{ sumText }}
          </span>
        </div>
        <div v-if="ordersSum" class="sum-count">
          <span>
            סכום
            <span class="sum-content" :class="[mode]"
              >₪{{ Number(ordersSum.toFixed(2)).toLocaleString() }}</span
            >
          </span>
        </div>
      </div>
    </div>
    <div class="table-lines">
      <slot v-if="sumCount > 0"> </slot>
      <NotFound v-else class="mt-5" title="לא נמצאו נתונים..." />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NotFound from "./NotFound.vue";
import TinyLabel from "./TinyLabel.vue";
import FilterButton from "./FilterButton.vue";

export default {
  components: { NotFound, TinyLabel, FilterButton },
  emits: ["label-click"],
  props: {
    title: {
      type: String,
    },
    mode: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
    },
    sumCount: {
      type: Number,
      default: 0,
    },
    ordersSum: {
      type: Number,
      default: 0,
    },
    // New props for dynamic labels
    labels: {
      type: Array,
      default: () => [],
    },
    showLabels: {
      type: Boolean,
      default: false,
    },
    showFilterButton: {
      type: Boolean,
      default: true,
    },
    filterMode: {
      type: String,
      default: "customers",
    },
    isTablet: {
      type: Boolean,
      default: false,
    },
    isLaptop: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onLabelClick(filterKey) {
      if (filterKey) {
        this.$emit("label-click", filterKey);
      }
    },
  },
  computed: {
    ...mapGetters({
      isMobile: "isMobile",
    }),
    sumText() {
      switch (this.mode) {
        case "customer":
          return "לקוחות";
        case "order":
          return "הזמנות";
        case "controlPanel":
          return "בקשות";
        default:
          return "";
      }
    },
  },
};
</script>
<style scoped lang="scss">
.table-container {
  position: relative;
  border: 1px solid $grayBorderColor;
  border-radius: 20px;
}

.table-header {
  background: #fafafa;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  font-size: $mediumTextSize;
  font-weight: 500;
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
  flex-wrap: wrap;
  gap: 10px;

  .sum-count {
    font-size: $mediumTextSize;
  }
}

.labels-section {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.clickable-label {
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.7;
  }
}

.active-label {
  background: $secondaryColor !important;
  color: $primaryColor !important;
  border: 2px solid $customerMainColor !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

@media only screen and (max-width: 601px) {
  .table-header {
    font-size: $mediumTextSize;
    flex-direction: column-reverse;
    align-items: flex-start;
    gap: 15px;
    padding: 10px;
  }

  .labels-section {
    order: 1;
    width: 100%;
  }

  .table-header-title {
    order: 2;
  }

  .sum-count {
    order: 3;
  }

  // .sum-count {
  //   font-size: 17px !important;
  // }
}

@include media(tablet, smallLaptop) {
  .table-container {
    margin-bottom: 5px;
  }
}
.table-lines {
  // padding: 20px;
  padding-top: 0px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
  // overflow-y: scroll;
  max-height: 480px;
}
@include media(laptop, desktop) {
  .table-lines {
    max-height: 600px;
  }
}

@media only screen and (max-width: 1024px) {
  .table-lines {
    max-height: 60vh !important;
  }
}

.sum-content.customer,
.table-header-title.customer,
.table-header-title .v-icon.customer {
  color: $customerMainColor;
}

.sum-content.order,
.table-header-title.order,
.table-header-title .v-icon.order {
  color: $ordersMainColor;
}

.sum-content.controlPanel,
.table-header-title.controlPanel,
.table-header-title .v-icon.controlPanel {
  color: $controlPanelMainColor;
}
</style>
